import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    AppBar,
    Toolbar,
    Grid,
    Hidden,
    Typography
} from '@material-ui/core';

import {
    currentLanguage,
} from "src/shared_modules/i18n";

import VisitorButton from "./visitor-button"
import AccountMenu from "./account-menu";
import HelpButton from "./help-button";
import ChatButton from "./chat-button";
import LoginButton from "./login-button";
import LanguageSwitch from './language-switch';
import MobileMenuButton from './mobile-menu-button';

import MobileMenu from "./mobile-menu";

import './mainnav.css';


class MainNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen : false,
        }
    }

    componentDidMount() {
        this.renderEventName = this.renderEventName.bind(this);
        this.handleMenuButtonClick = this.handleMenuButtonClick.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    handleMenuButtonClick() {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    }

    closeMenu() {
        this.setState({ isMenuOpen: false });
    }

    renderEventName() {
        let lang = currentLanguage().code2;
        let eventname = this.props.eventname[lang];

        if( !this.props.eventlogo ) {
            return(<div className="app-name">
                    <Typography variant="h6" component="span" color="primary">
                        {eventname}
                    </Typography>
                </div>);
        }

        let langpath = this.props.eventlogo[lang];
        let fallbackpath = this.props.eventlogo["en"];
        let logoUrl = "";

        if (langpath) {
            logoUrl = this.props.cdn.content.url + "/medialib/image/" + langpath;
        } else if (fallbackpath) {
            logoUrl = this.props.cdn.content.url + "/medialib/image/" + fallbackpath;
        }

        return(<div className="app-name">
                <img className="event-logo" src={logoUrl} alt={eventname} />
            </div>);
    }

    renderLogo() {

        //    background-image: url("/visitor/assets/logo.png");
        let icon={
            backgroundImage: `url("${process.env.PUBLIC_URL}/assets/logo.png")`
        }

        return(<div className="app-logo" style={icon}></div>);
    }

    render() {
        //console.warn("size " + this.props.className + " breakpoint "  + this.props.renderBreakpoint )

        return (<React.Fragment>
                    <AppBar style={{backgroundColor: "white"}} id="main-nav" position="fixed" className={this.props.className}>
                        <Toolbar>
                            <Grid container
                                    direction="row"
                                    justify="space-between"
                                    alignItems="center"
                                    wrap="nowrap"
                                >
                                <Hidden mdDown>
                                  <Grid container item xl={5} lg={5} wrap="nowrap" alignItems="center" >
                                      <Hidden  xlUp>
                                          <MobileMenuButton onClick={this.handleMenuButtonClick}/>
                                          <ChatButton />
                                      </Hidden>
                                      {this.renderEventName()}
                                  </Grid>
                                </Hidden>

                                <Hidden lgDown>
                                    <Grid container item xl={2} justify="center" alignItems="center">
                                        <VisitorButton/>
                                    </Grid>
                                </Hidden>

                                <Hidden lgUp>
                                    <Grid container item xs={6} justify="flex-start" alignItems="center">
                                        <MobileMenuButton onClick={this.handleMenuButtonClick}/>
                                        <ChatButton />
                                    </Grid>
                                </Hidden>

                                <Grid container item xl={5} lg={4} xs={6} justify="flex-end" alignItems="center" wrap="nowrap">

                                    <Hidden lgDown>
                                        <HelpButton />
                                        <LoginButton />
                                        <ChatButton />
                                        <AccountMenu themedStyle={this.props.themedStyle} />
                                        <LanguageSwitch themedStyle={this.props.themedStyle} />
                                    </Hidden>
                                    {this.renderLogo()}
                                </Grid>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Hidden xlUp>
                        <MobileMenu isOpen={this.state.isMenuOpen} onClose={this.closeMenu} className={this.props.className} />
                    </Hidden>
            </React.Fragment>);
    }
}

/*
 * ---------------------------------------------------------------------
 * MainNav prop Types
 * ---------------------------------------------------------------------
 */
MainNav.propTypes = {
    eventname : PropTypes.object,
    eventlogo : PropTypes.object,
    lang: PropTypes.string,
};
/*
 * ---------------------------------------------------------------------
 * MainNav Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        eventname: state.event.name,
        eventlogo: state.event.logoPath,
        lang: state.system.currentLang,
        cdn: state.system.cdn,
    };
};

const mapDispatchToProps = {
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */

export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(MainNav);
